export default {
  title: 'Kasse',
  labels: {
    login: 'Login und nutze deine gespeicherten Infos und Loyalty Punkte',
    continue_as_guest: 'ODER ALS GAST FORTFAHREN ',
  },
  buttons: {
    login: 'Login',
    demo_mode: 'Demo Modus',
  },
};
